import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const socket = io(SOCKET_URL, {
    autoConnect: true,
    transports: ["websocket"],
});

// ✅ Join customer room for multi-tenant isolation
socket.on("connect", () => {
    rejoinCustomerRoom();
});

// ✅ Helper function to join customer room - call this after login!
export function rejoinCustomerRoom() {
    const token = sessionStorage.getItem("token") || localStorage.getItem("token");
    if (token) {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const customer_id = payload.customer_id;
            if (customer_id) {
                console.log(`📡 Joining customer room: customer_${customer_id}`);
                socket.emit("join_customer_room", { customer_id });
            }
        } catch (e) {
            console.error('Failed to decode token:', e);
        }
    }
}
